import { clsx } from "clsx";
import { forwardRef, type ForwardRefRenderFunction, type LabelHTMLAttributes, type PropsWithChildren } from "react";

import style from "./Label.module.css";

export type LabelProps = LabelHTMLAttributes<HTMLLabelElement>;

const LabelRender: ForwardRefRenderFunction<HTMLLabelElement, PropsWithChildren<LabelProps>> = (props, ref) => {
  return (
    <label {...props} className={clsx(props.className, style.label)} ref={ref} data-testid="label">
      {props.children}
    </label>
  );
};

export const Label = forwardRef(LabelRender);
